<template>
    <div class="col-md-12 mx-auto container-fluid" v-bind:id="tracking.getUID()">
        <div class="buildingCardContainer">
            <div class="buildingCardContainer-body">
                <div class="flexContainer">
                    <div class="flexContainer-item">

                        <div class="card buildingCard dashboardMapCard">
                            <div class="card-body buildingCard-body">
                                <h5 class="card-title buildingCard-title">
                                    <i class="far fa-map buildingCard-title-icon"></i>
                                    Map View
                                    <span class="badge badge-info" style="float: right;">Total Sites: {{Object.values(buildingSummaryStatus).reduce((a, b) => a + b)}}</span>
                                </h5>
                                <div v-if="buildingList.length" class="card-text mapCardContent">
                                    <div class="staticMapContainer staticMapContainer-dynamic google-map" ref="googleMap"
                                         v-bind:class="{loaded: google}"
                                    ></div>
                                    <div ref="googleMapPlaceHolder"
                                    ></div>

                                    <div class="buildingCard-summary">
                                        <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-danger"
                                           v-bind:class="[currentFilter.buildingStatus === 'Overdue' ? 'textInner-danger-selected' : '']"
                                           v-on:click="toggleFilter('Overdue')"
                                        >
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-danger-apply">{{buildingSummaryStatus['Overdue']}}</div>
                                            <div class="buildingCard-summary-desc text-secondary">Overdue</div>
                                        </a>
                                        <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-warning"
                                           v-bind:class="[currentFilter.buildingStatus === 'Ongoing Tests' ? 'textInner-warning-selected' : '']"
                                           v-on:click="toggleFilter('Ongoing Tests')"
                                        >
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-warning-apply">{{buildingSummaryStatus['Ongoing Tests']}}</div>
                                            <div class="buildingCard-summary-desc text-secondary">Ongoing Tests</div>
                                        </a>
                                        <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-info"
                                           v-bind:class="[currentFilter.buildingStatus === 'Testing Soon' ? 'textInner-info-selected' : '']"
                                           v-on:click="toggleFilter('Testing Soon')"
                                        >
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-info-apply">{{buildingSummaryStatus['Testing Soon']}}</div>
                                            <div class="buildingCard-summary-desc text-secondary">Testing Soon</div>
                                        </a>
                                        <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-success"
                                           v-bind:class="[currentFilter.buildingStatus === 'Compliant' ? 'textInner-success-selected' : '']"
                                           v-on:click="toggleFilter('Compliant')"
                                        >
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-success-apply">{{buildingSummaryStatus['Compliant']}}</div>
                                            <div class="buildingCard-summary-desc text-secondary">Compliant</div>
                                        </a>
                                        <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-secondary"
                                           v-bind:class="[currentFilter.buildingStatus === 'No AFSS' ? 'textInner-secondary-selected' : '']"
                                           v-on:click="toggleFilter('No AFSS')"
                                        >
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-secondary-apply">{{buildingSummaryStatus['No AFSS']}}</div>
                                            <div class="buildingCard-summary-desc text-secondary">No AFSS</div>
                                        </a>
                                        <template v-if="buildingSummaryStatus['N/A']">
                                            <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                                                <a href="javascript:void(0)" class="col text-decoration-none buildingCard-summary-col textInner-secondary"
                                                   v-bind:class="[currentFilter.buildingStatus === 'N/A' ? 'textInner-secondary-selected' : '']"
                                                   v-on:click="toggleFilter('N/A')"
                                                >
                                                    <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-secondary-apply">{{buildingSummaryStatus['N/A']}}</div>
                                                    <div class="buildingCard-summary-desc text-secondary">N/A</div>
                                                </a>
                                            </RequiresGlobalPermissions>
                                        </template>
                                    </div>
                                </div>
                                <div v-else class="card-text mapCardContent">
                                    <div class="staticMapContainer emptyContent">
                                        <div class="emptyContent-default">
                                            <h2 class="emptyContent-default-title text-light"><i class="far fa-map"></i></h2>
                                            <p class="emptyContent-default-desc text-light">You have no buildings in EMIoT</p>
                                        </div>
                                    </div>
                                    <div class="buildingCard-summary">
                                        <div class="col text-decoration-none buildingCard-summary-col textInner-danger">
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-danger-apply">0</div>
                                            <div class="buildingCard-summary-desc text-secondary">Overdue</div>
                                        </div>
                                        <div class="col text-decoration-none buildingCard-summary-col textInner-warning">
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-warning-apply">0</div>
                                            <div class="buildingCard-summary-desc text-secondary">Ongoing Tests</div>
                                        </div>
                                        <div class="col text-decoration-none buildingCard-summary-col textInner-info">
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-info-apply">0</div>
                                            <div class="buildingCard-summary-desc text-secondary">Testing Soon</div>
                                        </div>
                                        <div class="col text-decoration-none buildingCard-summary-col textInner-success">
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-success-apply">0</div>
                                            <div class="buildingCard-summary-desc text-secondary">Compliant</div>
                                        </div>
                                        <div class="col text-decoration-none buildingCard-summary-col textInner-secondary">
                                            <div class="buildingCard-summary-title buildingCard-summary-title-smaller textInner-secondary-apply">0</div>
                                            <div class="buildingCard-summary-desc text-secondary">No AFSS</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flexContainer-item-sub">

                        <div class="flexContainer-item">
                            <div class="card buildingCard buildingCard-listContainer">
                                <div class="card-body buildingCard-body">
                                    <h5 class="card-title buildingCard-title clearfix">
                                        <i class="far fa-calendar-alt buildingCard-title-icon"></i>
                                        Calendar
                                    </h5>

                                    <div v-if="calendar.length" class="buildingCard-table-container">
                                        <table class="table buildingCard-table buildingCard-table-lg buildingCard-table-info calendarTable list">
                                            <thead>
                                            <tr>
                                                <th class="buildingHeadCol">BUILDING</th>
                                                <th class="testTypeHeadCol">TEST TYPE</th>
                                                <th class="statusHeadCol">STATUS</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <template v-for="(building, index) in calendar">
                                                <tr key:building.id>
                                                    <td class="buildingCol">
                                                        <div class="textBlock">
                                                            <div class="textBlock-icon"><i class="far fa-building"></i></div>
                                                            <a class="link-row textBlock-desc" v-bind:href="`/building-management/list-buildings#b:${building.id}`" v-on:click.prevent="pageToBuildingManagement(building.id, 'calendar')">
                                                                <div class="textBlock-desc-main">{{building.name}}</div>
                                                                <div class="textBlock-desc-sub">{{building.fullAddress}}</div>
                                                            </a>
                                                        </div>
                                                    </td>
                                                    <td>
                                                      <span v-if="building.test_current_report_type === 'annual'">Annual</span>
                                                      <span v-else-if="building.test_current_report_type === 'six-months'">6 Monthly</span>
                                                      <span v-else>N/A</span>
                                                    </td>
                                                    <td>
                                                        <ToolTip>
                                                            <template v-if="building.building_status === 'Overdue'">
                                                                <span v-bind:data-original-title="building.building_status_date ? tools.formatDate(new Date(building.building_status_date * 1000)) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">
                                                                    <i class="far fa-times-circle text-danger"></i>
                                                                    Overdue
                                                                    {{tools.humanizedTimeSpan(new Date(building.building_status_date * 1000), new Date())}}
                                                                </span>
                                                            </template>
                                                            <template v-else-if="building.building_status === 'Ongoing Tests'">
                                                                <template v-if="building.test_current_status === 'started'">
                                                                    <span>
                                                                        <i class="fas fa-sync text-warning"></i>
                                                                        Testing right now
                                                                    </span>
                                                                </template>
                                                                <template v-else>
                                                                    <span v-bind:data-original-title="building.building_status_date ? tools.formatDate(new Date(building.building_status_date * 1000)) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">
                                                                        <i class="far fa-hourglass text-warning"></i>
                                                                        Ongoing, due
                                                                        {{tools.humanizedTimeSpan(new Date(building.building_status_date * 1000), new Date())}}
                                                                    </span>
                                                                </template>
                                                            </template>
                                                            <template v-else-if="building.building_status === 'Testing Soon'">
                                                                <span v-bind:data-original-title="building.building_status_date ? tools.formatDate(new Date(building.building_status_date * 1000)) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">
                                                                    <i class="far fa-clock text-info"></i>
                                                                    Testing
                                                                    {{tools.humanizedTimeSpan(new Date(building.building_status_date * 1000), new Date())}}
                                                                </span>
                                                            </template>
                                                            <template v-else-if="building.building_status === 'Compliant'">
                                                                <span v-bind:data-original-title="building.building_status_date ? tools.formatDate(new Date(building.building_status_date * 1000)) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">
                                                                    <i class="far fa-check-circle text-success"></i>
                                                                    Compliant -
                                                                    <i class="far fa-file-pdf"></i>
                                                                    <a href="javascript:void(0)"
                                                                       v-on:click="requestReport(building.id, building.test_building_test_id, 'repair', getReportName('repair', building.test_report_status));
                                                                                   tracking.logEvent('testReport opened', {buildingId: building.id, reportDate: (new Date(building.test_report_execution_date * 1000)).toISOString(), reportType: building.test_report_type, reportResult: building.test_report_status, dashboardSection: 'calendar'});">
                                                                        Test report
                                                                    </a>
                                                                </span>
                                                            </template>
                                                        </ToolTip>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="emptyContent">
                                        <div class="emptyContent-default">
                                            <h2 class="emptyContent-default-title text-light"><i class="far fa-calendar-alt"></i></h2>
                                            <p class="emptyContent-default-desc text-light">There are no buildings with recent test activity.</p>
                                        </div>
                                    </div>

                                    <template v-if="false && calendarSettings.totalPage > 1">
                                        <paginate
                                                v-model="calendarSettings.currentPage"
                                                :page-count="calendarSettings.totalPage"
                                                :click-handler="calendarPageCallback"
                                                :prev-text="'Prev'"
                                                :next-text="'Next'"
                                                :container-class="'pagination justify-content-center pagination-tight'"
                                                :page-class="'page-item'"
                                                :prev-link-class="'page-link'"
                                                :next-link-class="'page-link'"
                                                :page-link-class="'page-link'">
                                        </paginate>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="flexContainer-item">
                            <div class="card buildingCard buildingCard-listContainer">
                                <div class="card-body buildingCard-body">
                                    <h5 class="card-title buildingCard-title clearfix">
                                        <i class="far fa-clock buildingCard-title-icon"></i>
                                        Recent Activity
                                    </h5>
                                    <div v-if="activity.length" class="buildingCard-table-container">
                                        <table class="table buildingCard-table buildingCard-table-lg buildingCard-table-info activityTable list">
                                            <thead>
                                            <tr>
                                                <th class="dateHeadCol">DATE</th>
                                                <th class="statusHeadCol">ACTIVITY</th>
                                                <th class="buildingHeadCol">BUILDING</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <template v-for="(report, index) in pagedActivity">
                                                <tr key:building.id>
                                                    <td class="dateCol">
                                                        <ToolTip>
                                                            <span v-bind:data-original-title="report.maintenance_date ? tools.humanizedTimeSpan(new Date(report.maintenance_date * 1000), new Date()) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">{{report.maintenance_date ? tools.formatDate(new Date(report.maintenance_date * 1000)) : 'N/A'}}</span>
                                                        </ToolTip>
                                                    </td>
                                                    <td class="statusCol">
                                                        <i class="far fa-file-pdf"></i>
                                                        <template v-if="report.meta.files !== undefined && report.status === 'done'">
                                                            <a href="javascript:void(0)" v-on:click="
                                                                requestRecord(report.building_id, report.id, 'record', getReportName('record', report.status));
                                                                tracking.logEvent('maintenanceRecord opened', {buildingId: report.building_id});">
                                                                Maintenance Record
                                                            </a>
                                                        </template>
                                                        <span v-else>
                                                            Maintenance Record
                                                        </span>
                                                    </td>
                                                    <td class="buildingCol">
                                                        <div class="textBlock">
                                                            <div class="textBlock-icon"><i class="far fa-building"></i></div>
                                                            <a class="link-row textBlock-desc" v-bind:href="`/building-management/list-buildings#b:${report.building_id}`" v-on:click.prevent="pageToBuildingManagement(report.building_id, 'recentActivity')">
                                                                <div class="textBlock-desc-main">{{report.building.name}}</div>
                                                                <div class="textBlock-desc-sub">{{report.building.fullAddress}}</div>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="emptyContent">
                                        <div class="emptyContent-default">
                                            <h2 class="emptyContent-default-title text-light"><i class="far fa-clock"></i></h2>
                                            <p class="emptyContent-default-desc text-light">There have been no recent activities in the past 2 weeks.</p>
                                        </div>
                                    </div>

                                    <template v-if="activitySettings.totalPage > 1">
                                        <paginate
                                                v-model="activitySettings.currentPage"
                                                :page-count="activitySettings.totalPage"
                                                :click-handler="recentActivitiesPageCallback"
                                                :prev-text="'Prev'"
                                                :next-text="'Next'"
                                                :container-class="'pagination justify-content-center pagination-tight'"
                                                :page-class="'page-item'"
                                                :prev-link-class="'page-link'"
                                                :next-link-class="'page-link'"
                                                :page-link-class="'page-link'">
                                        </paginate>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card buildingCard">
                    <div class="card-body buildingCard-body">
                        <h5 class="card-title buildingCard-title">
                            <i class="fas fa-city buildingCard-title-icon"></i>
                            All Buildings
                        </h5>
                        <div class="card-text">

                            <div class="table-responsive" v-if="buildingList.length">
                                <table class="table buildingCard-table buildingCard-table-lg allBuildings">
                                    <thead>
                                    <tr>
                                        <th @click="sort('search', 'asc', undefined, true, true)" class="sort buildingCol">
                                            BUILDING
                                            <i class="fas" v-bind:class="[currentSort.field === 'search' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <th @click="sort(['status_error', 'status_warning', 'status_ok'], 'desc', undefined, true, false)" class="sort deviceStatus">
                                            DEVICE STATUS
                                            <i class="fas" v-bind:class="[currentSort.field[0] === 'status_error' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <th @click="sort('test_future_execution_date', 'asc', undefined, true, false)" class="sort nextTestDate">
                                            NEXT TEST DATE
                                            <i class="fas" v-bind:class="[currentSort.field === 'test_future_execution_date' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <th @click="sort('test_latest_afss_dead_line', 'asc', undefined, true, false)" class="sort afss">
                                            AFSS
                                            <i class="fas" v-bind:class="[currentSort.field === 'test_latest_afss_dead_line' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <th @click="sort('test_report', 'asc', undefined, true, false)" class="sort latestTestReport">
                                            LATEST TEST REPORT
                                            <i class="fas" v-bind:class="[currentSort.field === 'test_report' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <th @click="sort('test_report_execution_date', 'desc', undefined, false, false)" class="sort latestTestDate">
                                            LATEST TEST DATE
                                            <i class="fas" v-bind:class="[currentSort.field === 'test_report_execution_date' ? (currentSort.sort === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort text-light']"></i>
                                        </th>
                                        <!-- Extra column with more options only for site admins -->
                                        <th v-if="isSiteAdmin"></th>
                                    </tr>
                                    </thead>
                                    <tbody class="list">
                                    <tr v-for="building in sortedBuildings" v-bind:class="{ignored: isSiteAdmin && building.ignored_reason != null}">
                                        <td class="buildingCol">
                                            <div class="textBlock">
                                                <div class="textBlock-icon"><i class="far fa-building"></i></div>
                                                <a class="link-row textBlock-desc" v-bind:href="`/building-management/list-buildings#b:${building.id}`" v-on:click.prevent="pageToBuildingManagement(building.id, 'allBuildings')">
                                                    <div class="textBlock-desc-main">{{building.name}}</div>
                                                    <div class="textBlock-desc-sub">{{building.fullAddress}}</div>
                                                </a>
                                            </div>
                                        </td>
                                        <td data-title="Device status">
                                            <span v-if="building.status_error > 0" class="mr-1">
                                                <ToolTip><i class="fas fa-times-circle text-danger mr-1" data-original-title="Devices with errors" data-toggle="tooltip" data-placement="top" data-html="false"></i></ToolTip>
                                                {{building.status_error}}/{{building.test_qty}}
                                            </span>
                                            <span v-if="building.status_warning > 0" class="mr-1">
                                                <ToolTip><i class="fas fa-exclamation-triangle text-warnin mr-1" data-original-title="Devices with warnings" data-toggle="tooltip" data-placement="top" data-html="false"></i></ToolTip>
                                                {{building.status_warning}}/{{building.test_qty}}
                                            </span>
                                            <span v-if="building.status_ok > 0">
                                                <ToolTip><i class="fas fa-check-circle text-success mr-1" data-original-title="Devices OK" data-toggle="tooltip" data-placement="top" data-html="false"></i></ToolTip>
                                                {{building.status_ok}}/{{building.test_qty}}
                                            </span>
                                        </td>
                                        <td data-title="Next test date">
                                            <ToolTip>
                                                <span v-bind:data-original-title="building.test_future_execution_date ? tools.humanizedTimeSpan(new Date(building.test_future_execution_date * 1000), new Date()) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">{{building.test_future_execution_date ? tools.formatDate(new Date(building.test_future_execution_date * 1000)) : 'N/A'}}</span>
                                            </ToolTip>
                                        </td>
                                        <td data-title="AFSS">
                                            <ToolTip>
                                                <span v-if="building.dead_line" v-bind:data-original-title="building.test_latest_afss_dead_line ? tools.humanizedTimeSpan(new Date(building.test_latest_afss_dead_line * 1000), new Date()) : 'Setup Required'" data-toggle="tooltip" data-placement="top" data-html="false">{{building.test_latest_afss_dead_line ? tools.formatDate(new Date(building.test_latest_afss_dead_line * 1000)) : 'N/A'}}</span>
                                                <span v-else data-original-title="Setup Required">Setup Required</span>
                                            </ToolTip>
                                        </td>
                                        <td data-title="Last test report">
                                            <span v-if="!building.test_report">
                                                N/A
                                            </span>
                                            <span v-else>
                                                <div class="reportList-list-sub-item-mainlink">
                                                  <i class="far fa-file-pdf"></i>
                                                  <a href="javascript:void(0)"
                                                     v-on:click="requestReport(building.id, building.test_building_test_id, 'repair', getReportName('repair', building.test_report_status));
                                                                 tracking.logEvent('testReport opened', {buildingId: building.id, reportDate: (new Date(building.test_report_execution_date * 1000)).toISOString(), reportType: building.test_report_type, reportResult: building.test_report_status, dashboardSection: 'allBuildings'});">
                                                      {{building.test_report}}
                                                  </a>
                                                  <i v-if="!building.test_report_failed" class="icon icon-post far fa-check-circle text-success"></i>
                                                  <i v-else class="icon icon-post far fa-times-circle text-danger"></i>
                                                </div>
                                            </span>
                                        </td>
                                        <td data-title="Last test date">
                                            <ToolTip>
                                                <span v-bind:data-original-title="building.test_report_execution_date ? tools.humanizedTimeSpan(new Date(building.test_report_execution_date * 1000), new Date()) : 'N/A'" data-toggle="tooltip" data-placement="top" data-html="false">{{building.test_report_execution_date ? tools.formatDate(new Date(building.test_report_execution_date * 1000)) : 'N/A'}}</span>
                                            </ToolTip>
                                        </td>
                                        <td v-if="isSiteAdmin">
                                          <button class="btn btn-sm btn-white" data-toggle="dropdown">
                                            <i class="fas fa-ellipsis-h"></i>
                                          </button>
                                          <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" v-on:click.prevent="showIgnoredReasonModal(building.id)">
                                              Ignored reason
                                            </a>
                                          </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="emptyContent">
                                <div class="emptyContent-default">
                                    <h2 class="emptyContent-default-title text-light"><i class="fas fa-city"></i></h2>
                                    <p class="emptyContent-default-desc text-light">You have no buildings in EMIOT.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <InfoComponent v-if="dataToPassToInfoModal.showModal"
                       @close="dataToPassToInfoModal.showModal = false"
                       v-bind:confirm="dataToPassToInfoModal"></InfoComponent>
        <EmbedModalComponent v-if="dataToPassToEmbedModal.showModal"
                             @close="dataToPassToEmbedModal.showModal = false"
                             v-bind:url="dataToPassToEmbedModal.url"
                             v-bind:mime="dataToPassToEmbedModal.mime"></EmbedModalComponent>
        <div id="ignored-reason-modal" class="modal fade" role="dialog" aria-labelledby="ignored-reason-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ignoredReasonModalBuilding == null ? '' : ignoredReasonModalBuilding.name}}: Ignored reason</h5>
                <button type="button" class="close" aria-label="Close" v-on:click="hideIgnoredReasonModal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <textarea v-model="ignoredReasonModalText"></textarea>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" v-on:click="hideIgnoredReasonModal">Close</button>
                <button type="button" class="btn btn-primary" v-on:click="submitIgnoredReasonModal">Save changes</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/../sass/_home_dashboard.scss";
    @import "@/../sass/_grid.scss";
</style>
<script>
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";
import Tools from '@/app-model/tools.js';
import Report from '@/app-model/report.js';
import Building from '@/app-model/building.js';
import EmbedModalComponent from '@/components/modal/EmbedModalComponent.vue';
import InfoComponent from '@/components/modal/InfoComponent.vue';
import ToolTip from '@/components/tool-tip/ToolTip.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import Tracking from '@/tracking/tracking.js';
import TrackingConfig from '@/tracking/config/dashboard.js';

const STATUS = {
    'Overdue': 0,
    'Ongoing Tests': 0,
    'Testing Soon': 0,
    'Compliant': 0,
    'No AFSS': 0,
  };
  const PIN_MARKER = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";

  export default {
    components: {
      RequiresGlobalPermissions,
      InfoComponent,
      EmbedModalComponent,
      ToolTip
    },
    data() {
      return {
        activity: [],
        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        dataToPassToEmbedModal: {
          showModal: false,
          url: '',
        },
        currentSort: {
          field: 'search',
          sort: 'asc',
          emptyLast: true,
          numberLast: true,
        },
        currentFilter: {
          buildingStatus: undefined
        },
        reportStatus: {},
        calendarSettings: {
          totalPage: 0,
          currentPage: 1,
          perPage: 4,
        },
        activitySettings: {
          totalPage: 0,
          currentPage: 1,
          perPage: 4,
        },
        google: null,
        map: null,
        mapInitialized: false,
        markers: {},
        photos: {},
        ignoredReasonModalBuilding: null,
        ignoredReasonModalText: null,
      }
    },
    computed: {
      buildingList: function () {
        return this.tools.noRefData(this.$store.getters.buildings);
      },
      tools: function () {
        return new Tools;
      },
      tracking: function () {
        return new Tracking(this, TrackingConfig, 'dashboard');
      },
      dateTimeFormat: function () {
        return new Intl.DateTimeFormat('en-AU', {month: 'short', day: 'numeric'});
      },
      buildingModel: function () {
        return new Building;
      },
      reportModel: function () {
        return new Report;
      },
      pagedActivity() {
        let start = (this.activitySettings.currentPage - 1) * this.activitySettings.perPage,
          end = start + this.activitySettings.perPage,
          total = this.activity.length;

        if (total > this.activitySettings.perPage + 1) {
          this.activitySettings.totalPage = parseInt(Math.ceil(total / this.activitySettings.perPage));
        }
        else {
          end = this.activitySettings.perPage + 1;
        }
        return this.activity.slice(start, end);
      },
      calendar() {
        let minDate = new Date(), tsMin;
        minDate.setDate((new Date()).getDate() - 14);
        tsMin = minDate.getTime() / 1000;

        let buildings = this.buildingList.filter(building => {
          return building.building_status_date &&
            (
              ['Overdue', 'Ongoing Tests', 'Testing Soon'].indexOf(building.building_status) > -1 ||
              (
                tsMin < building.building_status_date &&
                building.building_status !== 'No AFSS'
              )
            );
        });

        return this.tools.sort(
          buildings,
          this.tools.chainFields('building_status_date'),
          true
        );
      },
      pagedCalendar() {
        let start = (this.calendarSettings.currentPage - 1) * this.calendarSettings.perPage,
          end = start + this.calendarSettings.perPage,
          total = this.calendar.length;

        if (total > this.calendarSettings.perPage + 1) {
          this.calendarSettings.totalPage = parseInt(Math.ceil(total / this.calendarSettings.perPage));
        }
        else {
          end = this.calendarSettings.perPage + 1;
        }
        return this.calendar.slice(start, end);
      },
      sortedBuildings() {
        return this.tools.sort(
          this.buildingList,
          this.tools.chainFields(this.currentSort.field),
          this.currentSort.sort !== 'desc',
          this.currentSort.emptyLast,
          {numeric: true, sensitivity: 'base'},
          undefined,
          this.currentSort.numberLast
        ).filter(el => {
          let found = !this.currentFilter.buildingStatus || this.currentFilter.buildingStatus === el.building_status;
          let marker = this.markers?.[el.id];

          if(marker) {
            marker.setVisible(found);
          }
          return found;
        });
      },
      buildingSummaryStatus() {
        let status = Object.assign({}, STATUS);
        for(let i = 0; i < this.buildingList.length; i++) {
          let building = this.buildingList[i];
          if (this.isSiteAdmin && building.ignored_reason != null) {
            // This building should be ignored for the purposes of being included in the status calculations
            continue;
          }
          if (status[building.building_status] === undefined) {
            status[building.building_status] = 0;
          }
          status[building.building_status]++;
        }

        return status;
      },
      imgSrcAll() {
        return {
          'small': this.imgSrc(this.sortedBuildings, 400, 300, 2),
          'normal': this.imgSrc(this.sortedBuildings, 640, 400, 1),
        };
      },
      isSiteAdmin() {
        return this.$store.getters.hasGlobalPermissions({requiredPermissions: ['DEVELOPER_MODE']});
      }
    },
    created() {
      if (!this.buildingList.length) {
        this.buildingModel.loadBuildings({store: this.$store}).then(response => {
          this.loadActivity();
          this.loadGoogleMaps();
        });
      }
      else {
        this.loadActivity();
        this.loadGoogleMaps();
      }

      this.tracking.logEvent('dashboardScreen viewed');
    },
    mounted() {
      this.tracking.attachInstance();
    },
    methods: {
      pageToBuildingManagement: function(buildingId, source) {
        this.$store.state.router.push({name: 'building-management', hash: `#b:${buildingId}`});
        this.tracking.logEvent('buildingLink clicked', {
          dashboardSection: source
        });
      },
      toggleFilter: function (val) {
        this.currentFilter.buildingStatus = this.currentFilter.buildingStatus === val ? undefined : val;
        this.tracking.logEvent('mapView filtered', {
          filter: this.currentFilter.buildingStatus ? this.currentFilter.buildingStatus : 'reset'
        });
      },
      calendarPageCallback(page) {
        this.tracking.logEvent('pagination clicked', {list: 'calendar', page, pageSize: this.calendarSettings.totalPage});
      },
      recentActivitiesPageCallback(page) {
        this.tracking.logEvent('pagination clicked', {list: 'recentActivities', page, pageSize: this.activitySettings.totalPage});
      },
      sort: function (search, defaultSort, sort, emptyLast, numberLast) {
        let found = false;

        if (search === this.currentSort.field || (this.tools.isArrayish(search) && JSON.stringify(search) === JSON.stringify(this.currentSort.field))) {
          found = true;
        }

        if (found && sort === undefined) {
          sort = this.currentSort.sort === 'asc' ? 'desc' : 'asc';
        }
        else {
          sort = defaultSort;
        }

        this.currentSort.sort = sort;
        this.currentSort.field = search;
        this.currentSort.emptyLast = emptyLast;
        this.currentSort.numberLast = numberLast;

        this.tracking.logEvent('allBuildings sorted', {
          column: search,
          order: sort,
        });
      },
      imgSrc(buildings, w, h, scale) {
        let locations = [];
        for (let i in buildings) {
          let building = buildings[i];
          locations.push({
            latitude: building.latitude,
            longitude: building.longitude,
            address: building.fullAddress,
            color: building.statusStyle[0]
          });
        }
        return this.tools.mapImgSrc(locations, undefined, w, h, scale, false);
      },
      loadActivity() {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/user-building-maintenance-records?per_page=100',
          path_template: '/api/user-building-maintenance-records'
        }).then(response => {
          switch (response.status) {
            case 200 :
              this.activity = [];
              for (let i = 0; i < response.data.data.length; i++) {
                this.activity.push(Object.assign({}, response.data.data[i], {building: this.$store.getters.building({buildingId: response.data.data[i].building_id})}));
              }
              break;
          }
          return response;
        });
      },
      getReportName(reportType, status) {
        return this.reportModel.getReportName(reportType, status);
      },
      requestRecord(buildingId, buildingTestId, reportTitle) {
        return this.reportModel.requestRecord(
          {
            store: this.$store,
            infoModal: this.dataToPassToInfoModal,
            embedModal: this.dataToPassToEmbedModal
          },
          buildingId,
          buildingTestId,
          reportTitle
        );
      },
      requestReport(buildingId, buildingTestId, reportType, reportTitle) {
        return this.reportModel.requestReport(
          {
            store: this.$store,
            infoModal: this.dataToPassToInfoModal,
            embedModal: this.dataToPassToEmbedModal
          },
          buildingId,
          buildingTestId,
          reportType,
          reportTitle
        );
      },
      loadGoogleMaps: async function () {
        if(!this.buildingList.length) {
          return;
        }

        const googleMapApi = await GoogleMapsApiLoader({
          apiKey: window.GOOGLE_MAP_API_KEY,
          libraries: ['places'],
        });
        this.google = googleMapApi;
        this.map = new this.google.maps.Map(
          this.$refs.googleMap
          , {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            styles: [
              {
                featureType: "all",
                elementType: "all",
                stylers: [{ "saturation": -60 }],
              },

              {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [{ "visibility": "off" }],
              },
              {
                featureType: "poi",
                elementType: "labels.icon",
                stylers: [{ "visibility": "off" }],
              },
              {
                featureType: "road",
                elementType: "all",
                stylers: [{ "visibility": "off" }],
              },
              {
                featureType: "transit",
                elementType: "all",
                stylers: [{ "visibility": "off" }],
              },
            ]
          }
        );

        this.populateMarkers(this.buildingList);
      },
      populateMarkers: function(buildingList) {
        let imgPlaceholder = '<!-- img -->';
        let bounds = new this.google.maps.LatLngBounds();
        let infowindow = new this.google.maps.InfoWindow();
        let geocoder = new this.google.maps.Geocoder();
        let placesService = new this.google.maps.places.PlacesService(this.$refs['googleMapPlaceHolder']);
        for (let i = 0; i < buildingList.length; i++) {
          let building = buildingList[i];
          if(!building.latitude || !building.longitude) {
            continue;
          }
          // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
          let markerImage = {
            path: PIN_MARKER,
            anchor: new this.google.maps.Point(12, 17),
            fillOpacity: 1,
            fillColor: `#${building.statusStyle[0]}`,
            strokeWeight: 1,
            strokeColor: "white",
            scale: 1.5,
            labelOrigin: new this.google.maps.Point(12,9)
          };
          let position = {
            lat: building.latitude,
            lng: building.longitude
          };
          let marker = new this.google.maps.Marker({
            map: this.map,
            position,
            label: {
              text: ' ',
              className: building.statusStyle[2] && building.test_current_status === 'started' ? building.statusStyle[2] : building.statusStyle[1],
              fontFamily: '"Font Awesome 5 Free"',
              fontSize: '13px',
              color: 'white'
            },
            icon: markerImage,
          });
          marker.setVisible(true);
          marker.addListener("click", (event) => {
            let html = `
            <div class="googleMapInfoPopup">
                <div class="mb-3 mt-2 list">
                    <a href="/building-management/list-buildings#b:${building.id}" target="_blank" class="link-row textBlock-desc" onclick="document.getElementById('${this.tracking.getUID()}').vueTracking.logEvent('buildingLink clicked', {dashboardSection: 'mapView'});">
                        <div class="textBlock-desc-main">${building.name}</div>
                        <div class="textBlock-desc-sub">${building.fullAddress}</div>
                    </a>
                </div>
                <div class="mb-3">
                    <i class="${building.statusStyle[2] && building.test_current_status === 'started' ? building.statusStyle[2] : building.statusStyle[1]} ${building.statusStyle[3]}"></i>
                    ${building.building_status === 'Ongoing Tests' && building.test_current_status === 'started' ? 'Currently testing' : building.building_status}
                </div>
                ${imgPlaceholder}
                <div class="buttons clearfix">
                    <a href="/building-management/list-buildings#b:${building.id}" target="_blank" class="btn btn-primary float-right btn-sm" onclick="document.getElementById('${this.tracking.getUID()}').vueTracking.logEvent('goToBuildingButton clicked'});">Go to Building</a>
                </div>
            </div>
            `;
            this.populatePlacePhoto(building, infowindow, geocoder, placesService, html, imgPlaceholder);
            infowindow.open(this.map, marker);

            this.tracking.logEvent('mapPin selected', {
              buildingId: building.id
            });
          });
          bounds.extend(position);
          this.markers[building.id] = marker;
        }

        this.map.fitBounds(bounds);
        this.map.panToBounds(bounds);
      },
      populatePlacePhoto: function(building, infowindow, geocoder, placesService, html, imgPlaceholder) {
        if (this.photos[building.id] === undefined) {
          this.photos[building.id] = '';
          geocoder.geocode({address: building.fullAddress}, ([{place_id = undefined} = undefined]) => {
            if (place_id) {
              placesService.getDetails({placeId: place_id, fields: ['photo']}, (placeResult, placesServiceStatus) => {
                if(placesServiceStatus === this.google.maps.places.PlacesServiceStatus.OK) {
                  let photo = placeResult?.photos?.[0], photoUrl;
                  if(photo) {
                    photoUrl = photo.getUrl({maxHeight: 250, maxWidth: 250});
                    this.photos[building.id] = `<div class="mb-3 googleMapInfoPopup-inner"><img src="${photoUrl}"/></div>`;
                    infowindow.setContent(html.replace(imgPlaceholder, this.photos[building.id]));
                  }
                }
              });
            }
          });
        }
        else {
          html = html.replace(imgPlaceholder, this.photos[building.id]);
        }

        infowindow.setContent(html);
      },
      showIgnoredReasonModal: function(buildingId) {
        this.ignoredReasonModalBuilding = this.buildingList.find((building) => building.id === buildingId);
        this.ignoredReasonModalText = this.ignoredReasonModalBuilding.ignored_reason;
        jQuery($('#ignored-reason-modal').modal('show'));
      },
      hideIgnoredReasonModal: function() {
        this.ignoredReasonModalBuilding = null;
        this.ignoredReasonModalText = null;
        jQuery($('#ignored-reason-modal').modal('hide'));
      },
      submitIgnoredReasonModal: function() {
        // If the reason is empty, we want to submit null to the server
        if (!this.ignoredReasonModalText || this.ignoredReasonModalText.length === 0) {
          this.ignoredReasonModalText = null;
        }
        const payload = {
          'ignored_reason': this.ignoredReasonModalText,
        };

        this.$store.dispatch('apiResult', {
          method: 'PATCH',
          path: `api/buildings/${this.ignoredReasonModalBuilding.id}`,
          data: payload,
          path_template: '/api/user-buildings/{building_id}',
          building_id: this.ignoredReasonModalBuilding.id,
        }).then(response => {
          this.disabled = false;

          switch (response.status) {
            case 200 :
              this.$store.commit('setState', {
                variable: 'buildings',
                value: this.buildingList.map((building) => {
                  if (building.id === this.ignoredReasonModalBuilding.id) {
                    // Modify the building that we just set the ignored reason for.
                    // We update the ignored reason in an immutable way.
                    return {
                      ...building,
                      'ignored_reason': this.ignoredReasonModalText,
                    }
                  } else {
                    return building;
                  }
                }),
              });
          }

          return response;
        }).then(response => {
          this.hideIgnoredReasonModal();
        });
      },
    }
  }
</script>